import { Injectable, InjectionToken } from '@angular/core';
import { ConfigService } from '@jms/ui/ui.standalone.services/config.service';;

export const WINDOW = new InjectionToken<string>('Window');

export function _window(): any {
  // return the global native browser window object
  return window;
}

export function _document(): any {
  // return the global native browser window object
  return document;
}

@Injectable({ providedIn: 'root' })
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}

@Injectable({ providedIn: 'root' })
export class DocumentRef {
  get nativeDocument(): any {
    return _document();
  }
}

@Injectable({ providedIn: 'root' })
export class ContextService {
  public readonly host: string;
  public readonly web: string;
  public readonly api: string;
  public readonly origin: string;

  constructor(public window: WindowRef, public document: DocumentRef) {
    const environment = ConfigService.environment;
    this.host = window.nativeWindow.location.host;
    this.web = window.nativeWindow.location.hostname;
    this.api = environment.api;
    this.origin = window.nativeWindow.location.origin;
  }
}
